function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EventEmitter from 'eventemitter3';
export class Whiteboard extends EventEmitter {
  constructor(view) {
    super();
    _defineProperty(this, "view", void 0);
    _defineProperty(this, "selfUserId", void 0);
    _defineProperty(this, "window", undefined);
    _defineProperty(this, "permissions", void 0);
    /**
       * 当前选中的工具
       */
    _defineProperty(this, "tool", void 0);
    /**
       * 字体大小
       */
    _defineProperty(this, "fontSize", void 0);
    /**
       * 虚线配置
       */
    _defineProperty(this, "dashArray", void 0);
    /**
       * 字体名称
       */
    _defineProperty(this, "fontFamily", void 0);
    /**
       * 描边颜色
       */
    _defineProperty(this, "strokeColor", void 0);
    /**
       * 填充颜色
       */
    _defineProperty(this, "fillColor", void 0);
    /**
       * 描边宽度
       */
    _defineProperty(this, "strokeWidth", void 0);
    /**
       * 是否允许用鼠标/触控板进行缩放和拖动画布
       */
    _defineProperty(this, "enableCameraByMouse", void 0);
    /**
       * 是否允许触摸屏上触摸事件进行缩放和拖动画布
       */
    _defineProperty(this, "enableCameraByTouch", void 0);
    /**
       * 相机超出边界时, 警示阴影的颜色, 默认 "#F44336"
       */
    _defineProperty(this, "cameraBoundaryColor", void 0);
    /**
       * 是否允许相机超出边界时, 警示高亮阴影, 默认 true
       */
    _defineProperty(this, "enableCameraBoundaryHighlight", void 0);
    _defineProperty(this, "getElementAttribute", void 0);
    _defineProperty(this, "setElementAttribute", void 0);
    /**
     * 设置性能模式状态, enabled 为 true 时开启性能模式, 否则关闭性能模式
     * 性能模式下, 白板会降低渲染质量及同步频率以提升性能, 适用于低性能设备或需要大量绘制元素的场景
     * @param {boolean} enabled
     */
    _defineProperty(this, "setPerformanceMode", void 0);
    /**
     * 获取当前是否处于性能模式
     */
    _defineProperty(this, "isPerformanceMode", void 0);
    /**
       * 删除白板元素
       * @param {string} pageId - 元素所属页面 id
       * @param {string} elementId - 元素 id
       */
    _defineProperty(this, "removeElement", void 0);
    _defineProperty(this, "getCurrentTool", void 0);
    _defineProperty(this, "setCurrentTool", void 0);
    /**
       * 设置画布区域背景色
       * @param {string} color - css 颜色值
       */
    _defineProperty(this, "setCanvasBackgroundColor", void 0);
    /**
       * 设置主题色, 主题色影响选中框和昵称的背景色
       * @param {string} color - css 颜色值
       */
    _defineProperty(this, "setThemeColor", void 0);
    /**
       * 切换到指定页面, 调用端需要有页面切换权限
       * @param {string} id - 指定要切换到的页面 id
       */
    _defineProperty(this, "gotoPage", void 0);
    /**
       * 添加页面, 如果页面已经存在则不做任何修改
       * @param {string} id - 指定要添加到的页面 id
       */
    _defineProperty(this, "addPage", void 0);
    _defineProperty(this, "deletePage", void 0);
    _defineProperty(this, "pageList", void 0);
    /**
       * 获取当前页面 id
       * @param {string=} userId - 指定要获取对应用户的当前页面 id, 不传 userId 参数则获取自己的当前页面 id
       */
    _defineProperty(this, "currentPageId", void 0);
    /**
       * 复制页面
       * @param {string} sourceId - 指定要复制的页面, string 类型指定 id
       * @param {string} targetId - 指定要复制到的页面, string 类型指定 id
       */
    _defineProperty(this, "clonePage", void 0);
    /**
       * 清空当前页面
       */
    _defineProperty(this, "clearPage", void 0);
    /**
       * 平移画布
       * @param {number} offsetX - x 轴偏移量
       * @param {number} offsetY - y 轴偏移量
       */
    _defineProperty(this, "translateCamera", void 0);
    /**
       * 以画布中心为固定点缩放画布
       * @param {number} scale - 缩放比例
       * @param {"center" | "top-left"} origin - 缩放原点, "center" 为画布中心, "top-left" 为画布左上角
       */
    _defineProperty(this, "scaleCamera", void 0);
    /**
       * 重置画布, 将画布缩放比例重置为 1, 平移量重置为 [0, 0]
       */
    _defineProperty(this, "resetCamera", void 0);
    /**
       * 是否显示用户光标
       */
    _defineProperty(this, "showLiveCursor", void 0);
    /**
       * 更新视口大小
       */
    _defineProperty(this, "updateViewport", void 0);
    /**
       * 为 userId 指定的用户设置页面, 调用需要有 `WhiteboardPermissionFlag.setOthersView` 权限,
       * userId 指定的用户的视角模式应为 `free`, 否则调用无效
       */
    _defineProperty(this, "setFreeModelUserPage", void 0);
    _defineProperty(this, "indexedNavigation", void 0);
    /**
       * 设置视角模式为自由模式, 可以修改自己或者他人视角, 修改他人视角需要 `WhiteboardPermissionFlag.setOthersView` 权限
       * @param {string=} userId 可选, 指定要修改视角的 userId, 默认修改自己的视角
       */
    _defineProperty(this, "setViewModeToFree", void 0);
    /**
       * 设置视角模式为跟随其他用户, 可以修改自己或者他人视角, 修改他人视角需要 `WhiteboardPermissionFlag.setOthersView` 权限
       * @param {string} flowId 指定要跟随的用户 id
       * @param {string=} userId 可选, 指定要修改视角的 userId, 默认修改自己的视角
       */
    _defineProperty(this, "setViewModeToFlow", void 0);
    /**
       * 设置视角模式为跟随白板主视角, 可以修改自己或者他人视角, 修改他人视角需要 `WhiteboardPermissionFlag.setOthersView` 权限
       * @param {string=} userId 可选, 指定要修改视角的 userId, 默认修改自己的视角
       */
    _defineProperty(this, "setViewModeToMain", void 0);
    /**
       * 获取视角模式
       * @param {string=} userId 可选, 默认获取自己的视角模式
       * @return {'free' | 'main' | string} `free` 表示自由视角, `main` 表示主视角, 其他 string 类型代表跟随视角, string 值为跟随的 userId
       */
    _defineProperty(this, "getViewModel", void 0);
    /**
       * 撤销
       */
    _defineProperty(this, "undo", void 0);
    /**
       * 重做
       */
    _defineProperty(this, "redo", void 0);
    /**
       * 光栅化指定页面的可视区域
       * @param {number} scale 缩放比例
       * @param {string=} page string 指示页码 id; number 指示 IndexedNavigation 页面索引; undefined 指示光栅化当前页
       * @return {Promise<string>} 异步返回光栅化结果, 图片 png 对应的 base64 url. 如果页面不存在返回 null
       */
    _defineProperty(this, "rasterizeViewport", void 0);
    /**
       * 光栅化指定页面包含所有元素的包围盒
       * @param {number} outputMaxWidth 输出图片最大宽度, 在保证高宽比的情况下限值输出图片的宽度小于等于此值
       * @param {number} outputMaxHeight 输出图片最大高度, 在保证高宽比的情况下限值输出图片的高度小于等于此值
       * @param {string=} page string 指示页码 id; number 指示 IndexedNavigation 页面索引; undefined 指示光栅化当前页
       * @return {Promise<string>} 异步返回光栅化结果, 图片 png 对应的 base64 url. 如果页面不存在返回 null
       */
    _defineProperty(this, "rasterizeElementsBounds", void 0);
    /**
       * 光栅化指定页面最大缩放区域, 如果没有指定 `WhiteboardOption.maxScaleRatio` 或者指定的值为 -1, 则按 `rasterizeViewport` 返回结果.
       * @param {number} scale 缩放比例
       * @param {string=} page string 指示页码 id; number 指示 IndexedNavigation 页面索引; undefined 指示光栅化当前页
       * @return {Promise<string>} 异步返回光栅化结果, 图片 png 对应的 base64 url. 如果页面不存在返回 null
       */
    _defineProperty(this, "rasterizeMaxBounds", void 0);
    /**
       * 设置输入类型, "pen" 仅接受手写笔输入, "any" 接受任意输入, 当首次侦测到手写笔输入时, 将自动切换为 "pen"
       * @param {"pen" | "any"} type 输入类型
       */
    _defineProperty(this, "setInputType", void 0);
    /**
       * 插入图片
       * @param {string} src 图片的 url, 仅支持 https 协议, 同时需要确保不存在跨域问题
       * @param {string|InsertImageOptions=} options 可选, 指定要插入到的页面 id 或插入配置, 默认插入到当前页面
       */
    _defineProperty(this, "insertImage", void 0);
    this.view = view;
  }
}